// extracted by mini-css-extract-plugin
export default {"app":"-XR0soUsI7ft+hOA+2j9ZA=="};